module.exports = __webpack_public_path__ + "img/gps.668839e9.svg";